import NoSleep from 'nosleep.js'

// Screen Wake Lock API に対応している場合はそちらを使い、
// 非対応の場合は NoSleep.js にフォールバックする
const supportsWakeLock = 'wakeLock' in navigator

let wakeLockSentinel = null
let noSleep = null
let wakeLockEnabled = false

function getNoSleep() {
  if (!noSleep) {
    noSleep = new NoSleep()
  }
  return noSleep
}

// Wake Lock API の場合、ページが再表示されたときにロックを再取得する
function handleVisibilityChange() {
  if (document.visibilityState === 'visible' && wakeLockEnabled) {
    requestWakeLock()
  }
}

async function requestWakeLock() {
  if (supportsWakeLock) {
    // 既にアクティブな sentinel がある場合はスキップ
    if (wakeLockSentinel !== null) return

    try {
      const sentinel = await navigator.wakeLock.request('screen')

      // request() の非同期完了までに disableWakeLock() が呼ばれた場合、
      // 取得した sentinel を即座にリリースする
      if (!wakeLockEnabled) {
        sentinel.release()
        return
      }

      wakeLockSentinel = sentinel
      wakeLockSentinel.addEventListener('release', () => {
        // OS やブラウザによる自動リリース時に sentinel をクリアする
        // （visibilitychange で再取得するため）
        wakeLockSentinel = null
      })
    } catch (e) {
      console.log('Wake Lock request failed:', e)
    }
  } else {
    try {
      getNoSleep().enable()
    } catch (e) {
      console.log('NoSleep enable failed:', e)
    }
  }
}

async function releaseWakeLock() {
  if (supportsWakeLock) {
    if (wakeLockSentinel) {
      try {
        await wakeLockSentinel.release()
      } catch (e) {
        console.log('Wake Lock release failed:', e)
      }
      wakeLockSentinel = null
    }
  } else {
    try {
      getNoSleep().disable()
    } catch (e) {
      console.log('NoSleep disable failed:', e)
    }
  }
}

export function enableWakeLock() {
  wakeLockEnabled = true
  if (supportsWakeLock) {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  }
  requestWakeLock()
}

export function disableWakeLock() {
  wakeLockEnabled = false
  if (supportsWakeLock) {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }
  releaseWakeLock()
}
